export function PoaTrigger(chatBotId: string) {
	if (typeof window.acquireIO !== 'undefined') {
		window?.acquireIO.max('text', chatBotId, null, false, 'bot');
	} else {
		console.error('Could not start chatbot');
	}
}
